<template>
  <mdb-container>
    <mdb-btn @click="addSubCategoryType" color="indigo">{{
      $t("add_new_subcategorytype")
    }}</mdb-btn>
    <DataTableAG
      :columns="columns"
      :getcontentpath="getsubcategorytypespath"
      jsonobject="subcategorytypes"
      :buttonList="['Muokkaa']"
      :key="componentKey"
      v-on:pressed-button1="editSubCategoryTypes"
      width="800px"
      height="750px"
    />
    <SubCategoryType
      v-if="editSubCategoryTypeModal"
      :modal-show="editSubCategoryTypeModal"
      :name="name"
      :description="description"
      :id="id"
      :active="active"
      :add-subcategorytype-state="addSubCategoryTypeState"
      v-on:modal-cancelled="editSubCategoryTypeCancelled"
      v-on:modal-ok="editSubCategoryTypeOk"
    />
  </mdb-container>
</template>

<script>
import SubCategoryType from "@/components/EditSubCategoryType.vue";
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbBtn, mdbContainer } from "mdbvue";
export default {
  name: "SubCategoryTypes",
  components: {
    mdbBtn,
    mdbContainer,
    SubCategoryType,
    DataTableAG,
  },
  methods: {
    loadingReady() {
      this.loadReady = true;
    },
    editSubCategoryTypeCancelled() {
      this.editSubCategoryTypeModal = false;
    },
    editSubCategoryTypeOk() {
      this.editSubCategoryTypeModal = false;
      this.componentKey += 1;
      this.$router.go();
    },
    editSubCategoryTypes(rowData) {
      this.id = rowData.id;
      this.name = rowData.name;
      this.description = rowData.description;
      this.addSubCategoryTypeState = false;
      this.editSubCategoryTypeModal = true;
    },
    addSubCategoryType() {
      this.addSubCategoryTypeState = true;
      this.editSubCategoryTypeModal = true;
    },
  },
  data: () => ({
    loadReady: false,
    editSubCategoryTypeModal: false,
    addSubCategoryTypeState: false,
    componentKey: 0,
    id: 0,
    name: "",
    description: "",
    visible: 1,
    getsubcategorytypespath: "/1.0/front/subcategorytypes",
    rows: [],
    columns: [
      {
        field: "id",
        headerName: "Id",
        width: 100,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "name",
        headerName: "Nimi",
        width: 150,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "description",
        headerName: "Kuvaus",
        width: 350,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() {},
};
</script>
